<template>
  <ModalDialog
    ref="dialog"
    title="Import Xero Contact"
    icon="fa-user-circle"
    :submitting="submitting"
    submitTitle="Import"
    :submitDisabled="!canImport"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="importForm" :labelColumnSize="3">
      <FormRow label="Xero Contact"><FormSearchableSelect :options="xeroContacts" v-model="xeroContact" field="xeroContact" :loading="loadingContacts" /></FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<style>
</style>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import IntegrationXeroAPIService from '@/integrations/xero/services/apiService'

export default {
  name: "XeroImportContactDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {    
  },
  data() {
    return {
      xeroContact: '',
      xeroContacts: [],
      importForm: {},
      loadingContacts: false,
      submitting: false,
    }
  },
  mounted() {

    // Get the contact list from xero (via server)
    var xeroService = new IntegrationXeroAPIService(this.$api)

    this.loadingContacts = true

    xeroService.getXeroContactList()
    .then(response => {
      this.$data.xeroContacts = response.data.map(contact => {
        return {
          name: contact.name,
          value: contact.contactID
        }
      })

      this.loadingContacts = false
    })
    .catch(err => {
      this.$data.importForm = this.processFormResponse(err)
      this.loadingContacts = false
    })
  },
  computed: {
    canImport() {
      return this.xeroContact != ''
    }
  },
  methods: {
    show() {
      // Reset form
      this.xeroContact = ''
      this.importForm = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true

      var xeroService = new IntegrationXeroAPIService(this.$api)

      // Get the contact details from the Xero contact
      xeroService.getContactFromXero(this.xeroContact)
      .then(response => {
        var contactDefaults = {}
        try {

          // Fill in the NewContact defaults
          // Must match the settings in contactNew.vue
          contactDefaults.name = response.data.name
          if(_.isArray(response.data.addresses) && response.data.addresses.length > 0) {
            contactDefaults.addressLine1 = response.data.addresses[0].addressLine1
            contactDefaults.addressLine2 = response.data.addresses[0].addressLine2
            contactDefaults.addressSuburb = response.data.addresses[0].city
            contactDefaults.addressPostcode = response.data.addresses[0].postalCode
            contactDefaults.addressState = response.data.addresses[0].region
            contactDefaults.addressCountry = response.data.addresses[0].country
          }
          contactDefaults.personFirstName = response.data.firstName
          contactDefaults.personLastName = response.data.lastName
          contactDefaults.personEmail = response.data.emailAddress
          contactDefaults.website = response.data.website
          if(response.data.isCustomer !== undefined)
            contactDefaults.isCustomer = response.data.isCustomer
          if(response.data.isSupplier !== undefined)
            contactDefaults.isSupplier = response.data.isSupplier

          // Phones
          if(_.isArray(response.data.phones) && response.data.phones.length > 0) {
            response.data.phones.forEach(phone => {
              if(phone.phoneNumber && phone.phoneNumber != '') {
                var number = phone.phoneCountryCode + phone.phoneAreaCode + phone.phoneNumber

                if(phone.phoneType == 'FAX')
                  contactDefaults.fax = number
                if(phone.phoneType == 'DEFAULT') {
                  contactDefaults.phone = number
                  contactDefaults.personPhone = number
                }
                if(phone.phoneType == 'MOBILE' && contactDefaults.personPhone == '') {
                  contactDefaults.personPhone = number
                }
              }
            })
          }

          contactDefaults.integrationData = {
            xero: {
              active: true,
              code: 'xero',
              name: 'Xero',
              description: `Linked to Xero contact ${contactDefaults.name}`,
              imagePath: '/glass/integrations/xero-small-logo.png',   // Should probably get this from integration record from server...
              linked: true,
              contactID: response.data.contactID
            }
          }

        } catch(err) {
          console.dir(err)
        }

        this.submitting = false
        this.modalClosed(contactDefaults)
        this.hide()
      })
      .catch(err => {
        this.submitting = false
        this.$data.importForm = this.processFormResponse(err)
      })
    }
  }
}
</script>